<template>
    <div class="subpage-wrapper">
        <div class="subpage-page__title">
            安全设置
        </div>
        <div class="detail-box">
            <div class="detail-item">
                <div class="item-title">
                    修改绑定手机
                </div>
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PhonePWD',
    data () {
        return {
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    .form-box {
        border-top: 1px solid $--color-border-base;
        padding-top: 60px;
        font-size: $--size-small;
    }
</style>
